import React, { useRef } from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment, Typography, useMediaQuery, useTheme } from '@mui/material';

const CustomTypo = ({ children, type, value, onChange, ...typoProps }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Typography
            sx={{
                fontSize: {
                    xs: "18px",
                    md: "20px",
                },
            }}
            {...typoProps}
        >
            {children}
        </Typography>
    );
};

export default CustomTypo;
